import { MutationTree } from "vuex";
import { AppState, AppView, LayoutType, ToastData, UserRole } from "./state";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<AppState> = {
  setToast(state, payload: ToastData) {
    state.toast = payload;
  },
  //setToast
  [defineVuexName(MODULES.APP.COMMITS.SET_TOAST)](state, payload: ToastData) {
    state.toast = payload;
  },
  setLayout(state, payload: { layout: LayoutType }) {
    state.layout = payload.layout;
  },
  //setLayout
  [defineVuexName(MODULES.APP.COMMITS.SET_LAYOUT)](state, payload: { layout: LayoutType }) {
    state.layout = payload.layout;
  },
  setAppView(state, payload: { appView: AppView }) {
    state.appView = payload.appView;
  },
  //setAppView
  [defineVuexName(MODULES.APP.COMMITS.SET_APP_VIEW)](state, payload: { appView: AppView }) {
    state.appView = payload.appView;
  },
  setCameraDeviceId(state, payload: string) {
    state.cameraDeviceId = payload ?? "";
  },
  //setCameraDeviceId
  [defineVuexName(MODULES.APP.COMMITS.SET_CAMERA_DEVICE_ID)](state, payload: string) {
    state.cameraDeviceId = payload ?? "";
  },
  setMicrophoneDeviceId(state, payload: string) {
    state.microphoneDeviceId = payload ?? "";
  },
  //setMicrophoneDeviceId
  [defineVuexName(MODULES.APP.COMMITS.SET_MICROPHONE_DEVICE_ID)](state, payload: string) {
    state.microphoneDeviceId = payload ?? "";
  },
  setSpeakerDeviceId(state, payload: string) {
    state.speakerDeviceId = payload ?? "";
  },
  //setSpeakerDeviceId
  [defineVuexName(MODULES.APP.COMMITS.SET_SPEAKER_DEVICE_ID)](state, payload: string) {
    state.speakerDeviceId = payload ?? "";
  },
  setUserRoleByView(state, payload: UserRole) {
    state.userRole = payload;
  },
  //setUserRoleByView
  [defineVuexName(MODULES.APP.COMMITS.SET_USER_ROLE_BY_VIEW)](state, payload: UserRole) {
    state.userRole = payload;
  },
  setLowBandWidth(state, payload: boolean) {
    state.isLowBandWidth = payload;
  },
  //setLowBandWidth
  [defineVuexName(MODULES.APP.COMMITS.SET_LOW_BAND_WIDTH)](state, payload: boolean) {
    state.isLowBandWidth = payload;
  },
  setReplacedClassId(state, payload: string) {
    state.replacedClassId = payload;
  },
  setHavePermissionCamera(state, payload: boolean) {
    state.havePermissionCamera = payload;
  },
  //setHavePermissionCamera
  [defineVuexName(MODULES.APP.COMMITS.SET_HAVE_PERMISSION_CAMERA)](state, payload: boolean) {
    state.havePermissionCamera = payload;
  },
  setHavePermissionMicrophone(state, payload: boolean) {
    state.havePermissionMicrophone = payload;
  },
  //setHavePermissionMicrophone
  [defineVuexName(MODULES.APP.COMMITS.SET_HAVE_PERMISSION_MICROPHONE)](state, payload: boolean) {
    state.havePermissionMicrophone = payload;
  },
  setEnabledFeatures(state, payload: string[]) {
    state.enabledFeatures = payload;
  },
  setLowBandWidthDueToDownlink(state, payload: boolean) {
    state.isLowBandWidthDueToDownlink = payload;
  },
};

export default mutations;
